import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "text-lg font-semibold" }
const _hoisted_4 = { class: "mt-2 text-gray-600" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_7 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "d-sm-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_11 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_12 = {
  key: 1,
  class: "text-info"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_17 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_18 = { class: "d-sm-flex align-items-center" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_21 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_22 = {
  key: 1,
  class: "text-info"
}
const _hoisted_23 = { key: 2 }
const _hoisted_24 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_25 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.deliveryNote.note_stock_ref), 1),
        _createElementVNode("p", _hoisted_4, [
          _cache[10] || (_cache[10] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.deliveryNote.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.getDate(_ctx.deliveryNote.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[11] || (_cache[11] = _createTextVNode(" | Agence : ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.deliveryNote.note_stock_agency_name), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des nouveaux colis")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (
              _ctx.auth.can('ADD_BL_S') && _ctx.deliveryNote.note_stock_delivered == 0
            )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewColis && _ctx.addNewColis(...args)))
              }, _cache[12] || (_cache[12] = [
                _createTextVNode(" Ajouter ", -1),
                _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "me-2 mb-0 text-nowrap" }, "Voir", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.pg1.per_page,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pg1.per_page) = $event)),
              _cache[2] || (_cache[2] = ($event: any) => (_ctx.getToAdd()))
            ],
            options: [10, 25, 50, 100],
            clearable: false,
            class: "per-page-selector d-inline-block me-3",
            style: {"width":"90px"}
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pg1.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher",
            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSearch(_ctx.getToAdd)))
          }, null, 544), [
            [_vModelText, _ctx.pg1.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "row-key": 'id',
          "select-options": {
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          },
          onSelectedRowsChange: _ctx.selectionChanged,
          onSelectAll: _ctx.onSelectAll
        }, {
          emptystate: _withCtx(() => _cache[14] || (_cache[14] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_11, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_13, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectedRowsChange", "onSelectAll"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.pg1,
          offset: 9,
          onPaginate: _ctx.getToAdd
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "border-b p-4" }, [
        _createElementVNode("h3", { class: "text-lg font-semibold" }, "Liste des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (
              _ctx.auth.can('ADD_BL_S') && _ctx.deliveryNote.note_stock_delivered == 0
            )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeNewColis && _ctx.removeNewColis(...args)))
              }, _cache[18] || (_cache[18] = [
                _createTextVNode(" Supprimer ", -1),
                _createElementVNode("i", { class: "flaticon-delete position-relative ms-5 fs-12" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "me-2 mb-0 text-nowrap" }, "Voir", -1)),
          _createVNode(_component_v_select, {
            modelValue: _ctx.pg2.per_page,
            "onUpdate:modelValue": [
              _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pg2.per_page) = $event)),
              _cache[7] || (_cache[7] = ($event: any) => (_ctx.getInNote()))
            ],
            options: [10, 25, 50, 100],
            clearable: false,
            class: "per-page-selector d-inline-block me-3",
            style: {"width":"90px"}
          }, null, 8, ["modelValue"]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pg2.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher",
            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSearch(_ctx.getInNote)))
          }, null, 544), [
            [_vModelText, _ctx.pg2.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          "row-key": 'id',
          rows: _ctx.rows2,
          responsive: "",
          "select-options": {
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => _cache[20] || (_cache[20] = [
            _createElementVNode("div", { class: "text-center py-4 text-gray" }, " Aucune entrées correspondants trouvés ", -1)
          ])),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_21, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_22, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[22] || (_cache[22] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_23, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.pg2,
          offset: 9,
          onPaginate: _ctx.getInNote
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ]))
}